import { render, staticRenderFns } from "./newsStoryADT.vue?vue&type=template&id=18cfd302&scoped=true"
import script from "./newsStoryADT.vue?vue&type=script&lang=js"
export * from "./newsStoryADT.vue?vue&type=script&lang=js"
import style0 from "./newsStoryADT.vue?vue&type=style&index=0&id=18cfd302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cfd302",
  null
  
)

export default component.exports